import React from 'react';

export default function LoadingSvg({className = '', ...props}) {
  return (
    <svg className={`LoadingSvg spinner ${className}`} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle className="path" fill="none" strokeWidth="1.5" strokeLinecap="round" cx="33" cy="33" r="32"></circle>
    </svg>
  );
}
